import React from 'react';
import PropTypes from 'prop-types';
import {STEPS_PROPTYPE, BREADCRUMBS_CLASSNAME, STEP_STATUS_ACTIVE} from '../helpers/consts';
import './index.scss';

const Breadcrumbs = ({
    navigateTo,
    steps,
    className,
    currentStep,
    disabled
}) => {

    const navigate = (e, step) => {
        e.preventDefault();

        if (disabled) {
            return;
        }

        navigateTo(step.id);
    };

    const classes = [BREADCRUMBS_CLASSNAME, className].join(' ').trim();

    return (
        <ul className={classes}>
            {steps && steps.length && steps.map((step) => (
                <li key={step.id} className={currentStep.id === step.id ? STEP_STATUS_ACTIVE : ''}>
                    <a href="#!" onClick={(e) => navigate(e, step)}>{step.title}</a>
                </li>
            ))}
        </ul>
    );
};


Breadcrumbs.propTypes = {
    navigateTo: PropTypes.func,
    steps: PropTypes.arrayOf(STEPS_PROPTYPE),
    className: PropTypes.string,
    currentStep: STEPS_PROPTYPE,
    disabled: PropTypes.bool
};

Breadcrumbs.defaultProps = {
    navigateTo: () => null,
    disabled: false
};

export default Breadcrumbs;